import { createApp } from 'vue'
import App from './App.vue'
import './assets/main.css' // Tailwind CSS
import router from './router'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import Swal from 'sweetalert2'

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// Swal만 전역으로 설정
app.config.globalProperties.$swal = Swal

app.use(router)
app.use(pinia)

// mount는 마지막에
app.mount('#app')
